// import React, {forwardRef, useImperativeHandle, useRef} from 'react';
// import {PDFExport} from '@progress/kendo-react-pdf';
// import {dojahIcon, pdfBg} from 'assets/images/images';

// const EventReport = forwardRef(({eventDetails = {}}, ref) => {
//   const pdfExportComponent = useRef(null);

//   useImperativeHandle(ref, () => ({
//     handleExportWithComponent: () => {
//       if (pdfExportComponent.current) {
//         pdfExportComponent.current.save();
//       }
//     },
//   }));

//   const Header = () => (
//     <div
//       className=" "
//       style={{
//         display: 'flex',
//         justifyContent: 'space-between',
//         alignItems: 'center',
//         marginBottom: '10px',
//         fontSize: '12px',
//         zIndex: 1,
//       }}
//     >
//       <div style={{display: 'flex', alignItems: 'center'}}>
//         <img src={dojahIcon} alt="Dojah Logo" width={24} height={20} />
//       </div>
//       <div style={{textAlign: 'right'}}>
//         <div style={{color: '#4A4A68', fontStyle: 'italic'}}>
//           Generated by Dojah
//         </div>
//         <div style={{color: '#727272', fontStyle: 'italic'}}>
//           {new Date().toLocaleDateString('en-GB', {
//             day: '2-digit',
//             month: 'short',
//             year: 'numeric',
//           })}{' '}
//           {new Date().toLocaleTimeString('en-US', {
//             hour: 'numeric',
//             minute: '2-digit',
//             hour12: true,
//           })}
//         </div>
//       </div>
//     </div>
//   );

//   const pageContainerStyle = {
//     width: '100%',
//     padding: '17px 28px',
//     position: 'relative',
//     minHeight: '1000px',
//     boxSizing: 'border-box',
//     display: 'flex',
//     flexDirection: 'column',
//     zIndex: 1,
//     backgroundImage: `url(${pdfBg})`,
//     backgroundRepeat: 'no-repeat',
//     backgroundPosition: 'center',
//     backgroundSize: 'contain',
//   };

//   return (
//     <div className="pdf-export-container   !bg-[#FFFFFF]">
//       <PDFExport
//         ref={pdfExportComponent}
//         paperSize="A4"
//         margin="40px"
//         fileName="Event_Report.pdf"
//         author="Dojah"
//         scale={0.8}
//       >
//         <div style={{...pageContainerStyle, pageBreakAfter: 'always'}}>
//           <Header />

//           <div
//             style={{
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'space-between',
//               marginBottom: '10px',
//             }}
//           >
//             <div
//               style={{
//                 fontSize: '16px',
//                 fontWeight: '500',
//                 color: '#080917',
//                 letterSpacing: '-1%',
//               }}
//             >
//               Events Report
//             </div>
//             <div style={{textAlign: 'right'}}>
//               <div
//                 style={{
//                   color: '#868C98',
//                   fontSize: '10px',
//                   marginBottom: '6px',
//                 }}
//               >
//                 Risk Level
//               </div>
//               <div
//                 style={{
//                   backgroundColor: '#B42318',
//                   color: 'white',
//                   fontSize: '10px',
//                   fontWeight: '500',
//                   padding: '4px 8px',
//                   borderRadius: '25px',
//                   display: 'inline-block',
//                 }}
//               >
//                 HIGH
//               </div>
//             </div>
//           </div>

//           <div style={{marginBottom: '10px'}}>
//             <div
//               style={{
//                 fontSize: '10px',
//                 fontWeight: '500',
//                 padding: '4px',
//                 backgroundColor: '#ECECEC',
//                 marginBottom: '4px',
//               }}
//             >
//               User Details
//             </div>
//             <table
//               style={{
//                 width: '100%',
//                 borderCollapse: 'collapse',
//                 fontSize: '10px',
//               }}
//             >
//               <tbody>
//                 <tr>
//                   <td
//                     style={{
//                       width: '15%',
//                       padding: '4px',
//                       backgroundColor: '#F5F5F5',
//                       color: '#868C98',
//                     }}
//                   >
//                     Name
//                   </td>
//                   <td style={{width: '70%', padding: '4px'}}>
//                     {eventDetails?.name || 'Ayomide Oso'}
//                   </td>
//                 </tr>
//                 <tr>
//                   <td
//                     style={{
//                       padding: '4px',
//                       backgroundColor: '#F5F5F5',
//                       color: '#868C98',
//                     }}
//                   >
//                     User ID
//                   </td>
//                   <td style={{padding: '4px'}}>
//                     {eventDetails?.userId ||
//                       '931fac0-6bfa-4b3c-842c-7840006d89b6'}
//                   </td>
//                 </tr>
//                 <tr>
//                   <td
//                     style={{
//                       padding: '4px',
//                       backgroundColor: '#F5F5F5',
//                       color: '#868C98',
//                     }}
//                   >
//                     Email Address
//                   </td>
//                   <td style={{padding: '4px'}}>
//                     {eventDetails?.email || 'fraudguy@fruad.com'}
//                   </td>
//                 </tr>
//                 <tr>
//                   <td
//                     style={{
//                       padding: '4px',
//                       backgroundColor: '#F5F5F5',
//                       color: '#868C98',
//                     }}
//                   >
//                     Account Number
//                   </td>
//                   <td style={{padding: '4px'}}>
//                     {eventDetails?.accountNumber || '1100018690'}
//                   </td>
//                 </tr>
//                 <tr>
//                   <td
//                     style={{
//                       padding: '4px',
//                       backgroundColor: '#F5F5F5',
//                       color: '#868C98',
//                     }}
//                   >
//                     Phone Number
//                   </td>
//                   <td style={{padding: '4px'}}>
//                     {eventDetails?.phoneNumber || '08033333333'}
//                   </td>
//                 </tr>
//               </tbody>
//             </table>
//           </div>

//           <div style={{marginBottom: '10px'}}>
//             <div
//               style={{
//                 fontSize: '10px',
//                 fontWeight: '500',
//                 padding: '4px',
//                 backgroundColor: '#ECECEC',
//                 marginBottom: '4px',
//               }}
//             >
//               Transaction Summary
//             </div>
//             <table
//               style={{
//                 width: '100%',
//                 borderCollapse: 'collapse',
//                 fontSize: '10px',
//               }}
//             >
//               <tbody>
//                 <tr>
//                   <td
//                     style={{
//                       width: '15%',
//                       padding: '4px',
//                       backgroundColor: '#F5F5F5',
//                       color: '#868C98',
//                     }}
//                   >
//                     Event Type
//                   </td>
//                   <td style={{width: '70%', padding: '4px'}}>
//                     {eventDetails?.eventType || 'Bank Payment'}
//                   </td>
//                 </tr>
//                 <tr>
//                   <td
//                     style={{
//                       padding: '4px',
//                       backgroundColor: '#F5F5F5',
//                       color: '#868C98',
//                     }}
//                   >
//                     Transaction Type
//                   </td>
//                   <td style={{padding: '4px'}}>
//                     <span
//                       style={{
//                         backgroundColor: '#F8EBEA',
//                         color: '#961D14',
//                         padding: '4px 8px',
//                         borderRadius: '25px',
//                         fontSize: '10px',
//                       }}
//                     >
//                       {eventDetails?.transactionType || 'DEBIT'}
//                     </span>
//                   </td>
//                 </tr>
//                 <tr>
//                   <td
//                     style={{
//                       padding: '4px',
//                       backgroundColor: '#F5F5F5',
//                       color: '#868C98',
//                     }}
//                   >
//                     Transaction Amount
//                   </td>
//                   <td style={{padding: '4px'}}>
//                     {eventDetails?.transactionAmount || 'NGN500,000.00'}
//                   </td>
//                 </tr>
//               </tbody>
//             </table>
//           </div>

//           <div style={{marginBottom: '10px'}}>
//             <div
//               style={{
//                 fontSize: '10px',
//                 fontWeight: '500',
//                 padding: '4px',
//                 backgroundColor: '#ECECEC',
//                 marginBottom: '4px',
//               }}
//             >
//               Event Details
//             </div>
//             <table
//               style={{
//                 width: '100%',
//                 borderCollapse: 'collapse',
//                 fontSize: '10px',
//               }}
//             >
//               <tbody>
//                 <tr>
//                   <td
//                     style={{
//                       width: '15%',
//                       padding: '4px',
//                       backgroundColor: '#F5F5F5',
//                       color: '#868C98',
//                     }}
//                   >
//                     Transaction ID
//                   </td>
//                   <td style={{width: '70%', padding: '4px'}}>
//                     {eventDetails?.transaction_id ||
//                       '8710b2e4-4946-4b4e-8541-99076392d171'}
//                   </td>
//                 </tr>
//                 <tr>
//                   <td
//                     style={{
//                       padding: '4px',
//                       backgroundColor: '#F5F5F5',
//                       color: '#868C98',
//                     }}
//                   >
//                     Received Date
//                   </td>
//                   <td style={{padding: '4px'}}>
//                     {eventDetails?.receivedDate || '23 May 2025'}
//                   </td>
//                 </tr>
//                 <tr>
//                   <td
//                     style={{
//                       padding: '4px',
//                       backgroundColor: '#F5F5F5',
//                       color: '#868C98',
//                     }}
//                   >
//                     Received Time
//                   </td>
//                   <td style={{padding: '4px'}}>
//                     {eventDetails?.receivedTime || '23:08 PM'}
//                   </td>
//                 </tr>
//               </tbody>
//             </table>
//           </div>

//           <div style={{marginBottom: '10px'}}>
//             <div
//               style={{
//                 fontSize: '10px',
//                 fontWeight: '500',
//                 padding: '4px',
//                 backgroundColor: '#ECECEC',
//                 marginBottom: '4px',
//               }}
//             >
//               Sender & Receiver Information
//             </div>
//             <table
//               style={{
//                 width: '100%',
//                 borderCollapse: 'collapse',
//                 fontSize: '10px',
//               }}
//             >
//               <tbody>
//                 <tr>
//                   <td
//                     style={{
//                       width: '9%',
//                       padding: '4px',
//                       backgroundColor: '#F5F5F5',
//                       color: '#868C98',
//                     }}
//                   >
//                     Sender Name
//                   </td>
//                   <td style={{width: '15%', padding: '4px'}}>
//                     {eventDetails?.senderName || 'Ayomide Oso'}
//                   </td>
//                   <td
//                     style={{
//                       width: '9%',
//                       padding: '4px',
//                       backgroundColor: '#F5F5F5',
//                       color: '#868C98',
//                     }}
//                   >
//                     Receiver Name
//                   </td>
//                   <td style={{width: '15%', padding: '4px'}}>
//                     {eventDetails?.receiverName || 'Ayomide Oso'}
//                   </td>
//                 </tr>
//                 <tr>
//                   <td
//                     style={{
//                       padding: '4px',
//                       backgroundColor: '#F5F5F5',
//                       color: '#868C98',
//                     }}
//                   >
//                     Sender Bank
//                   </td>
//                   <td style={{padding: '4px'}}>
//                     {eventDetails?.senderBank || 'Guaranty Trust Bank'}
//                   </td>
//                   <td
//                     style={{
//                       padding: '4px',
//                       backgroundColor: '#F5F5F5',
//                       color: '#868C98',
//                     }}
//                   >
//                     Receiver Bank
//                   </td>
//                   <td style={{padding: '4px'}}>
//                     {eventDetails?.receiverBank || 'Guaranty Trust Bank'}
//                   </td>
//                 </tr>
//                 <tr>
//                   <td
//                     style={{
//                       padding: '4px',
//                       backgroundColor: '#F5F5F5',
//                       color: '#868C98',
//                     }}
//                   >
//                     Sender Account
//                   </td>
//                   <td style={{padding: '4px'}}>
//                     {eventDetails?.senderAccount || '1100018690'}
//                   </td>
//                   <td
//                     style={{
//                       padding: '4px',
//                       backgroundColor: '#F5F5F5',
//                       color: '#868C98',
//                     }}
//                   >
//                     Receiver Account
//                   </td>
//                   <td style={{padding: '4px'}}>
//                     {eventDetails?.receiverAccount || '1100018690'}
//                   </td>
//                 </tr>
//                 <tr>
//                   <td
//                     style={{
//                       padding: '4px',
//                       backgroundColor: '#F5F5F5',
//                       color: '#868C98',
//                     }}
//                   >
//                     Sender Country
//                   </td>
//                   <td style={{padding: '4px'}}>
//                     {eventDetails?.senderCountry || 'North Korea'}
//                   </td>
//                   <td
//                     style={{
//                       padding: '4px',
//                       backgroundColor: '#F5F5F5',
//                       color: '#868C98',
//                     }}
//                   >
//                     Receiver Country
//                   </td>
//                   <td style={{padding: '4px'}}>
//                     {eventDetails?.receiverCountry || 'North Korea'}
//                   </td>
//                 </tr>
//               </tbody>
//             </table>
//           </div>

//           <div style={{marginBottom: '10px'}}>
//             <div
//               style={{
//                 fontSize: '10px',
//                 fontWeight: '500',
//                 padding: '4px',
//                 backgroundColor: '#ECECEC',
//                 marginBottom: '4px',
//               }}
//             >
//               Detection Analysis
//             </div>
//             <table
//               style={{
//                 width: '100%',
//                 borderCollapse: 'collapse',
//                 fontSize: '10px',
//               }}
//             >
//               <tbody>
//                 <tr>
//                   <td
//                     style={{
//                       width: '15%',
//                       padding: '4px',
//                       backgroundColor: '#F5F5F5',
//                       color: '#868C98',
//                     }}
//                   >
//                     Risk Score
//                   </td>
//                   <td style={{width: '85%', padding: '4px'}}>
//                     <span
//                       style={{
//                         borderRadius: '25px',
//                         padding: '4px 8px',
//                         backgroundColor: '#DC6803',
//                         color: 'white',
//                       }}
//                     >
//                       {eventDetails?.evaluation_result?.risk_score || '60'}
//                     </span>
//                   </td>
//                 </tr>
//                 <tr>
//                   <td
//                     style={{
//                       padding: '4px',
//                       backgroundColor: '#F5F5F5',
//                       color: '#868C98',
//                       verticalAlign: 'top',
//                     }}
//                   >
//                     Triggered Rules
//                   </td>
//                   <td style={{padding: '4px'}}>
//                     <span
//                       style={{
//                         backgroundColor: '#ECECEC',
//                         padding: '4px 12px',
//                         fontWeight: '700',
//                         borderRadius: '25px',
//                         display: 'inline-block',
//                         fontSize: '10px',
//                       }}
//                     >
//                       PAYMENTS MULTIPLE TIMES DURING THE NIGHT TIME
//                     </span>
//                   </td>
//                 </tr>
//                 <tr>
//                   <td colSpan="2" style={{padding: '4px 4px 4px 0'}}>
//                     <div style={{marginTop: '4px'}}>
//                       <span
//                         style={{
//                           backgroundColor: '#ECECEC',
//                           padding: '4px 12px',
//                           fontWeight: '700',
//                           borderRadius: '25px',
//                           display: 'inline-block',
//                           fontSize: '10px',
//                         }}
//                       >
//                         TRANSACTION COUNT LESS THAN 50 AND TRANSACTION AMOUNT
//                         GREATER THAN 1,000,000
//                       </span>
//                     </div>
//                   </td>
//                 </tr>
//                 <tr>
//                   <td colSpan="2" style={{padding: '4px 4px 4px 0'}}>
//                     <div style={{marginTop: '4px'}}>
//                       <span
//                         style={{
//                           backgroundColor: '#ECECEC',
//                           padding: '4px 12px',
//                           fontWeight: '700',
//                           borderRadius: '25px',
//                           display: 'inline-block',
//                           fontSize: '10px',
//                         }}
//                       >
//                         IP ADDRESS COMING FROM A COUNTRY OUTSIDE OF AFRICA
//                       </span>
//                     </div>
//                   </td>
//                 </tr>
//                 <tr>
//                   <td colSpan="2" style={{padding: '4px 4px 4px 0'}}>
//                     <div style={{marginTop: '4px'}}>
//                       <span
//                         style={{
//                           backgroundColor: '#ECECEC',
//                           padding: '4px 12px',
//                           fontWeight: '700',
//                           borderRadius: '25px',
//                           display: 'inline-block',
//                           fontSize: '10px',
//                         }}
//                       >
//                         ADDRESS VERIFICATION FOR CARD FAILED
//                       </span>
//                     </div>
//                   </td>
//                 </tr>
//                 <tr>
//                   <td colSpan="2" style={{padding: '4px 4px 4px 0'}}>
//                     <div style={{marginTop: '4px'}}>
//                       <span
//                         style={{
//                           backgroundColor: '#ECECEC',
//                           padding: '4px 12px',
//                           fontWeight: '700',
//                           borderRadius: '25px',
//                           display: 'inline-block',
//                           fontSize: '10px',
//                         }}
//                       >
//                         USER NAME IS EQUAL TO AYOMIDE OSO
//                       </span>
//                     </div>
//                   </td>
//                 </tr>
//               </tbody>
//             </table>
//           </div>

//           <div style={{flexGrow: 1}}></div>
//         </div>

//         <div style={pageContainerStyle}>
//           <Header />

//           <div style={{marginBottom: '10px'}}>
//             <div
//               style={{
//                 fontSize: '10px',
//                 fontWeight: '500',
//                 padding: '4px',
//                 backgroundColor: '#ECECEC',
//                 marginBottom: '4px',
//               }}
//             >
//               Data Enrichment
//             </div>
//             <table
//               style={{
//                 width: '100%',
//                 borderCollapse: 'collapse',
//                 fontSize: '10px',
//               }}
//             >
//               <tbody>
//                 <tr>
//                   <td
//                     style={{
//                       width: '15%',
//                       padding: '4px',
//                       backgroundColor: '#F5F5F5',
//                       color: '#868C98',
//                     }}
//                   >
//                     IP Address
//                   </td>
//                   <td style={{width: '70%', padding: '4px'}}>
//                     {eventDetails?.ipAddress || '192.10.10'}
//                   </td>
//                 </tr>
//                 <tr>
//                   <td
//                     style={{
//                       padding: '4px',
//                       backgroundColor: '#F5F5F5',
//                       color: '#868C98',
//                     }}
//                   >
//                     Region
//                   </td>
//                   <td style={{padding: '4px'}}>
//                     {eventDetails?.region || 'West Africa'}
//                   </td>
//                 </tr>
//                 <tr>
//                   <td
//                     style={{
//                       padding: '4px',
//                       backgroundColor: '#F5f5f5',
//                       color: '#868C98',
//                     }}
//                   >
//                     Country
//                   </td>
//                   <td style={{padding: '4px'}}>
//                     {eventDetails?.country || 'Nigeria'}
//                   </td>
//                 </tr>
//                 <tr>
//                   <td
//                     style={{
//                       padding: '4px',
//                       backgroundColor: '#F5f5f5',
//                       color: '#868C98',
//                     }}
//                   >
//                     ISP
//                   </td>
//                   <td style={{padding: '4px'}}>{eventDetails?.isp || 'MTN'}</td>
//                 </tr>
//                 <tr>
//                   <td
//                     style={{
//                       padding: '4px',
//                       backgroundColor: '#F5f5f5',
//                       color: '#868C98',
//                     }}
//                   >
//                     OS
//                   </td>
//                   <td style={{padding: '4px'}}>
//                     {eventDetails?.os || 'Linux'}
//                   </td>
//                 </tr>
//                 <tr>
//                   <td
//                     style={{
//                       padding: '4px',
//                       backgroundColor: '#F5f5f5',
//                       color: '#868C98',
//                     }}
//                   >
//                     Model
//                   </td>
//                   <td style={{padding: '4px'}}>
//                     {eventDetails?.model || 'Samsung'}
//                   </td>
//                 </tr>
//                 <tr>
//                   <td
//                     style={{
//                       padding: '4px',
//                       backgroundColor: '#F5f5f5',
//                       color: '#868C98',
//                     }}
//                   >
//                     Device ID
//                   </td>
//                   <td style={{padding: '4px'}}>
//                     {eventDetails?.deviceId || '234-1929-1929-293'}
//                   </td>
//                 </tr>
//               </tbody>
//             </table>
//           </div>

//           <div style={{flexGrow: 1}}></div>
//         </div>
//       </PDFExport>
//     </div>
//   );
// });

// EventReport.displayName = 'EventReport';

// export default EventReport;

import React from 'react';

function EventReport() {
  return <div></div>;
}

export default EventReport;
